import { render, staticRenderFns } from "./vb.vue?vue&type=template&id=3929fd90&scoped=true&"
import script from "./vb.vue?vue&type=script&lang=js&"
export * from "./vb.vue?vue&type=script&lang=js&"
import style0 from "./vb.vue?vue&type=style&index=0&id=3929fd90&scoped=true&lang=css&"
import style1 from "./vb.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3929fd90",
  null
  
)

export default component.exports